module.exports = __webpack_public_path__ + "static/img/10008 (1).3bcecc2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10008 (1).webp
// module id = BubD
// module chunks = 14